<template>
  <div class="payment-invalid-status" v-if="paymentFailed">
    <p class="body-text-bold error-text">
      {{ __('payment_failed_title') }}
    </p>

    <p class="body-text-bold">{{ __('payment_failed_subtitle') }}</p>
  </div>
  <div class="payment-status-page" v-else-if="product && order">
    <img :src="product.imageUrl" class="payment-status-page-image" />
    <div class="payment-status-page-info">
      <p class="section-title multiple-stars">
        {{ __('payment_success_title') }}
      </p>
      <p class="title-text">{{ __('payment_success_subtitle') }} {{ product.name }}!</p>
      <p class="body-text"></p>
      <router-link
        :to="{
          name: 'LandingPage',
        }"
        class="payment-status-page-info-back">
        <div class="arrow left-arrow"></div>
        <p class="body-text-bold primary-text">
          {{ __('back_to_home_screen') }}
        </p>
      </router-link>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import { Order, Product } from '@/types';
import axios from 'axios';
import router from '@/router';
import __ from '@/translate';

const product = ref<Product | null>(null);
const order = ref<Order | null>(null);
const paymentFailed = ref(false);

onMounted(async () => {
  const query = router.currentRoute.value.query;
  const params = router.currentRoute.value.params;
  const currentRouteName = router.currentRoute.value.name;

  if (!params.uuid) {
    router.push({ name: 'NotFound' });
    return;
  }

  if (currentRouteName === 'PaymentSuccessPage') {
    if (!query.payment_intent_client_secret) {
      router.push({ name: 'NotFound' });
      return;
    }
    await getOrder();
    if (!order.value?.paymentSuccessful) {
      paymentFailed.value = true;
      return;
    }
    await getProduct();
  } else if (currentRouteName === 'OrderSuccessPage') {
    await getOrder();

    if (order.value?.paymentMethod !== 'delivery') {
      router.push({ name: 'NotFound' });
      return;
    }

    await getProduct();
  } else {
    router.push({ name: 'NotFound' });
  }
});

function getOrder() {
  return axios
    .get(`/api/orders/${router.currentRoute.value.params.uuid}`)
    .then((response) => {
      order.value = response.data;
    })
    .catch(() => {
      router.push({ name: 'NotFound' });
    });
}

function getProduct() {
  return axios
    .get(`/api/products/${order.value?.productId}`)
    .then((response) => {
      product.value = response.data;
    })
    .catch(() => {
      router.push({ name: 'NotFound' });
    });
}
</script>
